export default function YouTubeFeed() {
  return (
    <section
      data-testid="youtube-feed"
      className="relative bg-ink-900 py-20 md:py-24 border-t border-ink-600"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <p className="tag-kicker">Latest on YouTube</p>
            <h2 className="font-display text-3xl md:text-4xl font-bold leading-[1.15] tracking-normal mt-3 max-w-2xl">
              More from the{" "}
              <span className="italic text-amber">Underground-Mix</span>{" "}
              channel.
            </h2>
          </div>
          <a
            href="https://www.youtube.com/@undergroundmixsync"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="youtube-channel-link"
            className="inline-flex items-center gap-2 bg-ink-800 hover:bg-amber hover:text-black border border-ink-600 hover:border-amber text-white font-bold uppercase tracking-wider text-xs px-5 py-3 rounded-sm transition-colors"
          >
            Subscribe on YouTube →
          </a>
        </div>

        <div
          data-testid="youtube-player-wrapper"
          className="relative overflow-hidden border border-ink-600 bg-black shadow-[0_20px_60px_-20px_rgba(34,197,94,0.15)]"
        >
          <div className="relative aspect-video max-w-4xl mx-auto">
            <iframe
              src="https://www.youtube-nocookie.com/embed/videoseries?list=UU4ThYaytMrIzwtqV0fnRAoQ&autoplay=0&mute=1&loop=1&modestbranding=1&rel=0&playsinline=1&controls=1"
              title="Latest from Underground Mix on YouTube"
              className="absolute inset-0 w-full h-full"
              frameBorder="0"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}
